<template>
  <nuttrema-layout-three-vertical class="is-in-mobile-ready-layout">

    <participant-standard-header
       slot="top"
       v-if="!PersonalProfile.fetching"
      :meta="meta"
      :edit.sync="edit"
      :showEdit="true"
      :showOnMobileAndTablet="showOnMobileAndTablet">
    </participant-standard-header>

    <template slot="middle">
      <nuttrema-loader v-if="PersonalProfile.fetching"></nuttrema-loader>
      <form-participant-deactivate-account
         v-else
        :edit.sync="edit"
        :PersonalProfile="PersonalProfile"
        @submit="onFormSubmit">
      </form-participant-deactivate-account>
    </template>

  </nuttrema-layout-three-vertical>
</template>

<script>
import { mapActions } from 'vuex';

import PageProps from 'components/mixins/page-props';
import ResponsiveMonitor from 'components/mixins/responsive-monitor';

import NuttremaLayoutThreeVertical from 'components/ui/layout/nuttrema-layout-three-vertical';
import ParticipantStandardHeader from 'components/pages/participant/shared/participant-standard-header';

import FormParticipantDeactivateAccount from './form-participant-deactivate-account';

export default {
  name: 'page-participant-deactivate-account',
  mixins: [
    PageProps,
    ResponsiveMonitor,
  ],
  data() {
    return {
      edit: false,
    };
  },
  components: {
    ParticipantStandardHeader,
    NuttremaLayoutThreeVertical,
    FormParticipantDeactivateAccount,
  },
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
  },
  methods: {
    ...mapActions([
      'PersonalDeactivateAccount',
    ]),
    onFormSubmit(payload) {
      this.PersonalDeactivateAccount({ payload }).then(() => {
        this.successNotification({ message: 'message.account_deactivated' });
        this.$router.push({ name: this.PAGES.PARTICIPANT.LOGOUT });
      }).catch((error) => {
        console.error(error);
        this.errorNotification();
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/participant/my-preferences/deactivate-account/page-participant-deactivate-account.vue